import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { faSleigh } from '@fortawesome/free-solid-svg-icons';

declare var $:any;

@Component({
  selector: 'horizontal-date-picker',
  templateUrl: './horizontal-date-picker.component.html',
  styleUrls: ['./horizontal-date-picker.component.css']
})
export class HorizontalDatePickerComponent implements OnInit {

  @Input()
  minDate=new Date();
  @Input()
  maxDate=new Date();
  @Input()
  defaultSelectDate=new Date();

  @Input()
  isLogin=false;

  @Output()
  pickerDate = new EventEmitter();

  months = [{mon:"January", val:1, isDisabled: false}, {mon:"February", val:2, isDisabled: false}, {mon:"March", val:3, isDisabled: false}, {mon:"April", val:4, isDisabled: false}, {mon:"May", val:5, isDisabled: false}, {mon:"June", val:6, isDisabled: false}, {mon:"July", val:7, isDisabled: false}, {mon:"August", val:8, isDisabled: false}, {mon:"September", val:9, isDisabled: false}, {mon:"October", val:10, isDisabled: false}, {mon:"November", val:11, isDisabled: false}, {mon:"December", val:12, isDisabled: false}];
  days=[];
  years=[];

  weekDays= {
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thur',
    5: 'Fri',
    6: 'Sat',
    0: 'Sun'
  }

  selectedDay=1;
  selectedMonth=0;
  selectedYear=0;
  leftDisable= false;
  rightDisable = false;
  prevDateValue=null;


  @ViewChild('hdpRef') hdpRef : ElementRef;

  constructor() { }

  ngOnInit() {
    this.setDefaultDate();
    this.scrollDefaultLength();
  }

  scrollDefaultLength() {
    if(this.selectedDay > 7) {
      var refInterval = setInterval(() => {
        if(this.hdpRef) {
          this.hdpRef.nativeElement.children[1].scrollLeft += (this.hdpRef.nativeElement.children[1].offsetWidth/100)*((this.selectedDay-6)*14);
          clearInterval(refInterval);
        }
      },500);
    }
  }

  setDefaultDate() {
    var day = this.defaultSelectDate.getDate();
    var month = this.defaultSelectDate.getMonth();
    var year = this.defaultSelectDate.getFullYear();
    this.selectedDay = day;
    this.selectedMonth = month+1;
    this.selectedYear = year;
    this.generateYears();
  }

  dateEventEmit() {
      var date = new Date(this.selectedMonth + '/' + this.selectedDay + '/' + this.selectedYear);
      if(!this.prevDateValue) {
        this.prevDateValue = date;
        this.pickerDate.emit(date);
      } else if(this.prevDateValue.valueOf() != date.valueOf()) {
        this.prevDateValue = date;
        this.pickerDate.emit(date);
      }
  }

  getDaysInMonth(month,year) {
    return new Date(year, month, 0).getDate();
  }

  generateDays() {
    var me = this;
    this.days = [];
    var currentMonth = this.selectedMonth;
    var currentYear = this.selectedYear;
    var daysCounter = this.getDaysInMonth(currentMonth, currentYear);
    for(var day=1; day<=daysCounter; day++) {
      var dayText= new Date(this.selectedMonth + '/' + day + '/' + this.selectedYear).getDay()
      this.days.push(
        {
          'day': day,
          'val':day,
          'isDisabled': false,
          'label': me.weekDays[dayText]
        }
      );
    }
    this.disableDays();

  }

  generateYears() {
    var minYear = this.minDate.getFullYear();
    var maxYear = this.maxDate.getFullYear();
    for(var year=minYear; year<=maxYear; year++) {
      this.years.push(
        {
          'year': year,
          'val':year,
          'isDisabled': false
        }
      );
    }
    this.disableMonths();
  }

  disableMonths() {
    if(this.selectedYear < this.maxDate.getFullYear() && this.selectedYear > this.minDate.getFullYear()) {
        this.months.forEach(month => {
          month.isDisabled = false;
        })
    } else if (this.selectedYear < this.maxDate.getFullYear() && this.selectedYear == this.minDate.getFullYear()) {
        this.months.forEach(month => {
          if(month.val < this.minDate.getMonth()+1) {
            month.isDisabled = true;
          } else {
            month.isDisabled = false;
          }
        });
    } else if (this.selectedYear == this.maxDate.getFullYear() && this.selectedYear > this.minDate.getFullYear()) {
      this.months.forEach(month => {
        if(month.val > this.maxDate.getMonth()+1) {
          month.isDisabled = true;
        } else {
          month.isDisabled = false;
        }
      });
    } else if (this.selectedYear == this.maxDate.getFullYear() && this.selectedYear == this.minDate.getFullYear()) {
      this.months.forEach(month => {
        if(month.val < this.minDate.getMonth()+1 || month.val > this.maxDate.getMonth()+1) {
          month.isDisabled = true;
        } else {
          month.isDisabled = false;
        }
      });
    }
    this.generateDays();
  }

  disableDays() {
    if(this.selectedYear < this.maxDate.getFullYear() && this.selectedYear > this.minDate.getFullYear()) {
      this.days.forEach(day => {
        day.isDisabled = false;
      })
  } else if (this.selectedYear < this.maxDate.getFullYear() && this.selectedYear == this.minDate.getFullYear()) {
    if(this.selectedMonth == this.minDate.getMonth()+1) {
      this.days.forEach(day => {
        if(day.val < this.minDate.getDate()) {
          day.isDisabled = true;
        } else {
          day.isDisabled = false;
        }
      });
    } else if (this.selectedMonth < this.minDate.getMonth()+1) {
      this.days.forEach(day => {
        day.isDisabled = true;
      });
    }
  } else if (this.selectedYear == this.maxDate.getFullYear() && this.selectedYear > this.minDate.getFullYear()) {
    if(this.selectedMonth == this.maxDate.getMonth()+1) {
      this.days.forEach(day => {
        if(day.val > this.maxDate.getDate()) {
          day.isDisabled = true;
        } else {
          day.isDisabled = false;
        }
      });
    } else if (this.selectedMonth > this.maxDate.getMonth()+1) {
      this.days.forEach(day => {
        day.isDisabled = true;
      });
    }
  } else if (this.selectedYear == this.maxDate.getFullYear() && this.selectedYear == this.minDate.getFullYear()) {
    if(this.maxDate.getMonth()+1 == this.minDate.getMonth()+1) {
      this.days.forEach(day => {
        if(day.val < this.minDate.getDate()) {
          day.isDisabled = true;
        } else if(day.val > this.maxDate.getDate()) {
          day.isDisabled = true;
        } else {
          day.isDisabled = false;
        }
      });
    }else if(this.selectedMonth == this.minDate.getMonth()+1) {
      this.days.forEach(day => {
        if(day.val < this.minDate.getDate()) {
          day.isDisabled = true;
        } else {
          day.isDisabled = false;
        }
      });
    } else if(this.selectedMonth == this.maxDate.getMonth()+1) {
      this.days.forEach(day => {
        if(day.val > this.maxDate.getDate()) {
          day.isDisabled = true;
        } else {
          day.isDisabled = false;
        }
      });
    }
  }
  this.checkMonthWiseDaysDifference();
  }

  checkMonthWiseDaysDifference() {
    if(this.selectedDay > this.days.length) {
      this.selectedDay = this.days.length;
    }
    this.dateEventEmit();
  }

  onDaySelectionChange(event) {
  }

  onMonthSelectionChange(event) {
    this.generateDays();
  }

  onYearSelectionChange(event) {
    this.disableMonths();
  }

  scrollLeft(parent) {
    parent.children[1].scrollLeft -= (parent.children[1].offsetWidth/100)*14;
    this.showHideScrollArrows(parent);
  }

  scrollRight(parent) {
   parent.children[1].scrollLeft += (parent.children[1].offsetWidth/100)*14;
   this.showHideScrollArrows(parent);
  }

  showHideScrollArrows(parent) {
    // if(parent && parent.children.length > 0) {
    //   if(parent.children[1].scrollLeft == 0) {
    //   //  $('.'+parent.children[0].className).hide();
    //   this.leftDisable=true;
    //   } else {
    //  //   $('.'+parent.children[0].className).show();
    //  this.leftDisable=false;
    //   }
    //   if((parent.children[1].scrollWidth - parent.children[1].scrollLeft) <= (parent.children[1].offsetWidth+5)) {
    //    // $('.'+parent.children[2].className).hide();
    //    this.rightDisable=true;
    //   } else {
    //   //  $('.'+parent.children[2].className).show();
    //   this.rightDisable=false;
    //   }
    // }
  }

  dayClicked(day) {
      this.selectedDay = day.day;
      this.dateEventEmit();
  }

  setPreviousDate() {
    var dt = new Date(this.selectedMonth + '/' + this.selectedDay + '/' + this.selectedYear);
    dt.setDate(dt.getDate() - 1);
    this.prevDateValue=dt;
    this.pickerDate.emit(dt);
  }

}
